export default function LegalCookies() {
  return (
    <section id="cookies" className="legal-section">
      <h2 className="legal-section-title">Cookie Policy</h2>
      <p className="legal-meta">Last Updated: {new Date().toISOString().slice(0, 10)}</p>

      <h3>1. What Are Cookies?</h3>
      <p>
        Cookies are small text files stored on your device when you visit a website or use an app.
        They help us recognise your device, remember preferences, and improve your experience.
      </p>

      <h3>2. How We Use Cookies</h3>
      <p>We use cookies and similar technologies for the following purposes:</p>
      <ul>
        <li>
          <strong>Essential Cookies:</strong> Required for the App to function, such as authentication
          and security.
        </li>
        <li>
          <strong>Preference Cookies:</strong> Remember your settings, such as dark mode or language
          preferences.
        </li>
        <li>
          <strong>Analytics Cookies:</strong> Help us understand how users interact with the App so we
          can improve it.
        </li>
        <li>
          <strong>Marketing Cookies:</strong> Used to deliver relevant promotions and measure their
          effectiveness.
        </li>
      </ul>

      <h3>3. Types of Cookies We Use</h3>
      <div className="legal-table-wrapper">
        <table className="legal-table">
          <thead>
            <tr>
              <th>Cookie Name</th>
              <th>Purpose</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>auth_token</td>
              <td>Keep you signed in securely</td>
              <td>Session</td>
            </tr>
            <tr>
              <td>theme_preference</td>
              <td>Remember light/dark mode</td>
              <td>Persistent</td>
            </tr>
            <tr>
              <td>analytics_consent</td>
              <td>Store your analytics consent choice</td>
              <td>Persistent</td>
            </tr>
            <tr>
              <td>_ga / _gid</td>
              <td>Google Analytics tracking</td>
              <td>Varies</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>4. Managing Cookies</h3>
      <p>
        Most browsers and devices allow you to manage or delete cookies through your settings. Please
        note that disabling essential cookies may prevent the App from working correctly.
      </p>
      <p>
        You can also manage analytics consent through the App&apos;s analytics settings. Marketing cookies
        are only used if you provide consent.
      </p>

      <h3>5. Third-Party Cookies</h3>
      <p>
        Some cookies are placed by third-party services we use, such as analytics providers. These
        third parties may use their own cookies in accordance with their privacy policies.
      </p>

      <h3>6. Changes to This Cookie Policy</h3>
      <p>
        We may update this Cookie Policy from time to time. Any changes will be posted alongside the
        Terms &amp; Conditions and Privacy Policy.
      </p>

      <h3>7. Contact Us</h3>
      <p>
        If you have questions about our use of cookies, contact us at{" "}
        <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || 'threads@voyagerbug.com'}`}>{process.env.REACT_APP_SUPPORT_EMAIL || 'threads@voyagerbug.com'}</a>.
      </p>
    </section>
  );
}
